export default __webpack_public_path__ + "static/media/EM0060.34I-19682_-14847_0.0f74a36e.jpg";